import { useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { href: '#services', label: 'Services' },
    { href: '#service-area', label: 'Coverage' },
    { href: '#gallery', label: 'Gallery' },
    { href: '#testimonials', label: 'Testimonials' },
    { href: '#faq', label: 'FAQ' },
    { href: '#contact', label: 'Contact' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-header" data-testid="header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a 
            href="#" 
            className="flex items-center gap-3"
            data-testid="logo"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            <img 
              src="/logo.png" 
              alt="Snake Rescue Bangalore Logo" 
              className="h-12 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollToSection(link.href)}
                className="text-[#4A4D4A] hover:text-[#2A4B35] font-medium transition-colors text-sm"
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </button>
            ))}
          </nav>

          {/* Emergency Call Button */}
          <div className="flex items-center gap-2">
            <a
              href="tel:+918310755854"
              className="hidden sm:flex"
              data-testid="header-call-btn-1"
            >
              <Button 
                className="bg-[#D9534F] hover:bg-[#c9433f] text-white font-semibold px-3 py-2 rounded-full emergency-pulse flex items-center gap-2 text-sm"
              >
                <Phone className="w-4 h-4" />
                <span className="hidden lg:inline">Alhan</span>
              </Button>
            </a>
            <a
              href="tel:+919845080903"
              className="hidden sm:flex"
              data-testid="header-call-btn-2"
            >
              <Button 
                className="bg-[#D9534F] hover:bg-[#c9433f] text-white font-semibold px-3 py-2 rounded-full emergency-pulse flex items-center gap-2 text-sm"
              >
                <Phone className="w-4 h-4" />
                <span className="hidden lg:inline">Mohan</span>
              </Button>
            </a>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden p-2 text-[#1A1D1A]"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              data-testid="mobile-menu-btn"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-[#D8D4C7]" data-testid="mobile-nav">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollToSection(link.href)}
                  className="text-[#4A4D4A] hover:text-[#2A4B35] font-medium transition-colors text-left py-2"
                  data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </button>
              ))}
              <a
                href="tel:+918310755854"
                className="mt-2"
                data-testid="mobile-call-btn-1"
              >
                <Button 
                  className="w-full bg-[#D9534F] hover:bg-[#c9433f] text-white font-semibold py-3 rounded-xl flex items-center justify-center gap-2"
                >
                  <Phone className="w-5 h-5" />
                  Call Alhan: +91 8310755854
                </Button>
              </a>
              <a
                href="tel:+919845080903"
                className="mt-2"
                data-testid="mobile-call-btn-2"
              >
                <Button 
                  className="w-full bg-[#D9534F] hover:bg-[#c9433f] text-white font-semibold py-3 rounded-xl flex items-center justify-center gap-2"
                >
                  <Phone className="w-5 h-5" />
                  Call Mohan: +91 9845080903
                </Button>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
